import styled from '@emotion/styled'

type PageHeaderProps = {
	title: string
}

const PageHeader = ({ title }: PageHeaderProps) => {
	return (
		<Block>
			<Title>{title}</Title>
		</Block>
	)
}

const Block = styled.div`
	margin-top: 3.5rem;
	margin-bottom: 7.1rem;
`

const Title = styled.h1`
	font-size: 2.4rem;
	font-weight: 700;
	line-height: 2.9rem;
	letter-spacing: 0.02rem;
`

export default PageHeader
